// Components
import PageHeader from '@/components/pages/reports/CreateEditPage/components/PageHeader';
// Type
import type { ReportFormProps } from '@/components/pages/reports/CreateEditPage/components/ReportForm';
import ReportForm from '@/components/pages/reports/CreateEditPage/components/ReportForm';

const CreateEditPage = (props: ReportFormProps) => (
    <div>
        <PageHeader isEdit={props.isEdit} />
        <ReportForm {...props} />
    </div>
);

export default CreateEditPage;
